"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _styledBase = _interopRequireDefault(require("@emotion/styled-base"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _grid = _interopRequireDefault(require("./grid"));
var FixedColumnComponent = (/*#__PURE__*/
0, _styledBase["default"])('div', {
  target: "e1xkhz1e0",
  label: "FixedColumnComponent"
})("> div{", _grid["default"].grid, " ", _grid["default"].separate, " @media only screen and (-ms-high-contrast:none){flex-direction:column;}}@media only screen and (-ms-high-contrast:none){min-width:300px;flex-grow:0;width:300px;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9MYXlvdXQvRml4ZWRDb2x1bW4uanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBSzBDIiwiZmlsZSI6Ii4uLy4uL3NyYy9MYXlvdXQvRml4ZWRDb2x1bW4uanMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgQ29tcG9uZW50IH0gZnJvbSAncmVhY3QnO1xuaW1wb3J0IFByb3BUeXBlcyBmcm9tICdwcm9wLXR5cGVzJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCBHcmlkIGZyb20gJy4vZ3JpZCc7XG5cbmNvbnN0IEZpeGVkQ29sdW1uQ29tcG9uZW50ID0gc3R5bGVkKCdkaXYnKWBcbiAgICA+IGRpdiB7XG4gICAgICAgICR7R3JpZC5ncmlkfVxuICAgICAgICAke0dyaWQuc2VwYXJhdGV9XG5cbiAgICAgICAgQG1lZGlhIG9ubHkgc2NyZWVuIGFuZCAoLW1zLWhpZ2gtY29udHJhc3Q6IG5vbmUpIHtcbiAgICAgICAgICAgIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW47XG4gICAgICAgIH1cbiAgICB9XG5cbiAgICBAbWVkaWEgb25seSBzY3JlZW4gYW5kICgtbXMtaGlnaC1jb250cmFzdDogbm9uZSkge1xuICAgICAgICBtaW4td2lkdGg6IDMwMHB4O1xuICAgICAgICBmbGV4LWdyb3c6IDA7XG4gICAgICAgIHdpZHRoOiAzMDBweDtcbiAgICB9XG5gO1xuXG5jbGFzcyBGaXhlZENvbHVtbiBleHRlbmRzIENvbXBvbmVudCB7XG4gIHJlbmRlcigpIHtcbiAgICBjb25zdCB7IGNoaWxkcmVuIH0gPSB0aGlzLnByb3BzO1xuXG4gICAgcmV0dXJuIChcbiAgICAgIDxGaXhlZENvbHVtbkNvbXBvbmVudCBkYXRhLWNvbXBvbmVudD17J0ZpeGVkQ29sdW1uJ30+XG4gICAgICAgIDxkaXY+XG4gICAgICAgICAgeyBjaGlsZHJlbiB9XG4gICAgICAgIDwvZGl2PlxuICAgICAgPC9GaXhlZENvbHVtbkNvbXBvbmVudD5cbiAgICApO1xuICB9XG59XG5cbkZpeGVkQ29sdW1uLmRpc3BsYXlOYW1lID0gJ0ZpeGVkQ29sdW1uJztcblxuRml4ZWRDb2x1bW4uZGVmYXVsdFByb3BzID0ge1xufTtcblxuRml4ZWRDb2x1bW4ucHJvcFR5cGVzID0ge1xuICBjaGlsZHJlbjogUHJvcFR5cGVzLm5vZGUsXG59O1xuXG5leHBvcnQgZGVmYXVsdCBGaXhlZENvbHVtbjtcbiJdfQ== */"));
var FixedColumn = /*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(FixedColumn, _Component);
  function FixedColumn() {
    (0, _classCallCheck2["default"])(this, FixedColumn);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(FixedColumn).apply(this, arguments));
  }
  (0, _createClass2["default"])(FixedColumn, [{
    key: "render",
    value: function render() {
      var children = this.props.children;
      return _react["default"].createElement(FixedColumnComponent, {
        "data-component": 'FixedColumn'
      }, _react["default"].createElement("div", null, children));
    }
  }]);
  return FixedColumn;
}(_react.Component);
FixedColumn.displayName = 'FixedColumn';
FixedColumn.defaultProps = {};
FixedColumn.propTypes = {
  children: _propTypes["default"].node
};
var _default = FixedColumn;
exports["default"] = _default;
FixedColumn.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "FixedColumn",
  "props": {
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    }
  }
};
if (typeof STORYBOOK_REACT_CLASSES !== "undefined") {
  STORYBOOK_REACT_CLASSES["src/Layout/FixedColumn.js"] = {
    name: "FixedColumn",
    docgenInfo: FixedColumn.__docgenInfo,
    path: "src/Layout/FixedColumn.js"
  };
}